import { render, staticRenderFns } from "./my-account.vue?vue&type=template&id=cf6acbb0&scoped=true&"
import script from "./my-account.vue?vue&type=script&lang=js&"
export * from "./my-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6acbb0",
  null
  
)

export default component.exports